import React from "react";
import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./Login_Header.css";
import BoloLogo from "../assets/BoloLogo.svg";
import Home_Page_Black from "../assets/Home_Page_Black.svg";
import Home_Page_Blue from "../assets/Home_Page_Blue.svg";

const Login_Header = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setShow(true); // show when scrolled
      } else {
        setShow(false); // hide at top
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  //   const observer = new IntersectionObserver(
  //     ([entry]) => {
  //       setShow(!entry.isIntersecting);
  //     },
  //     {
  //       rootMargin: "0px",
  //       threshold: 0.5,
  //     }
  //   );

  //   const targetElement = document.querySelector(".Image_Sub_Section");

  //   if (targetElement) {
  //     observer.observe(targetElement);
  //   }

  //   return () => {
  //     if (targetElement) {
  //       observer.unobserve(targetElement);
  //     }
  //   };
  // }, []);

  return (
    <header className={`bolo-header1 ${show ? "visible" : "hidden"}`}>
      <div>
        <div className="Bolo_Header_Status1">
          <div className="Bolo_Header1">
            <a href="/">
              <div className="Logo_Section1">
                <img className="Image1" src={BoloLogo} alt="BoloIndia Logo" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Login_Header;